import { api } from "./api";

export async function registerPushSubscription(): Promise<boolean> {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return false;

    try {
        const { publicKey } = await api.get<{ publicKey: string }>("/api/notifications/vapid-key");
        if (!publicKey) return false;

        const reg = await navigator.serviceWorker.ready;
        const existing = await reg.pushManager.getSubscription();
        if (existing) {
            await api.post("/api/notifications/subscribe", {
                endpoint: existing.endpoint,
                keys: {
                    p256dh: arrayBufferToBase64(existing.getKey("p256dh")!),
                    auth: arrayBufferToBase64(existing.getKey("auth")!),
                },
            });
            return true;
        }

        const sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey),
        });

        await api.post("/api/notifications/subscribe", {
            endpoint: sub.endpoint,
            keys: {
                p256dh: arrayBufferToBase64(sub.getKey("p256dh")!),
                auth: arrayBufferToBase64(sub.getKey("auth")!),
            },
        });
        return true;
    } catch (err) {
        console.error("[push] Registration failed:", err);
        return false;
    }
}

// Explicit Uint8Array<ArrayBuffer> return: TS 5.7's generic TypedArrays
// otherwise infer Uint8Array<ArrayBufferLike>, which no longer satisfies
// PushSubscriptionOptionsInit.applicationServerKey (BufferSource).
function urlBase64ToUint8Array(base64String: string): Uint8Array<ArrayBuffer> {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(base64);
    const arr = new Uint8Array(new ArrayBuffer(raw.length));
    for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
    return arr;
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
